import type { PlayerModelOption } from '@/library/PlayerModelsHelper';
import type { OrderSearchRequest } from '@/api/models';
import type { MultiSelectOption } from '@/common/MultiSelectDropdown';
import { ordersPresentation, OrdersPageType } from './OrdersPresentation';
import type { OrderSort } from './OrderSorting';

export const ORDERS_PER_PAGE = 50;

interface OrdersDashboardFilters {
  // TODO: Add more filter props as implemented
  searchUserDataOnly?: boolean;
}

export interface OrdersDashboardQuery {
  offset: number;
  filters: OrdersDashboardFilters;
  playerId?: number;
  playerName?: string;
  orderNo?: string;
  laserNo?: string;
  orderStatus: MultiSelectOption[];
  buildLocation: MultiSelectOption[];
  clubSupply: MultiSelectOption[];
  account: MultiSelectOption[];
  tourRep: MultiSelectOption[];
  playerModels: PlayerModelOption[];
  shipFrom?: MultiSelectOption[];
  shipTo?: MultiSelectOption[];
  requestedShipDate?: string;
  orderDateFrom?: string;
  orderDateTo?: string;
}

export const initialQuery: OrdersDashboardQuery = {
  offset: 0,
  filters: {},
  orderStatus: [],
  buildLocation: [],
  clubSupply: [],
  account: [],
  tourRep: [],
  playerModels: [],
};

export const initialSortBy: OrderSort = {
  column: 'orderDate',
  direction: 'desc',
};

export const buildSearchRequest = (query: OrdersDashboardQuery, sortBy: OrderSort, currentPage: OrdersPageType): OrderSearchRequest => {
  const request: OrderSearchRequest = {
    offline: false,
    orderTypes: [ordersPresentation[currentPage].orderType],
    pageNo: query.offset / ORDERS_PER_PAGE + 1,
    rowsPerPage: ORDERS_PER_PAGE,
  };

  if (sortBy) request.sortBy = sortBy;

  const toIds = (options: MultiSelectOption[]) => options.map((option) => Number(option.value));

  if (query.playerModels.length > 0) request.playerModels = query.playerModels.map((option) => option.configuration);
  if (query.playerId !== undefined) request.playerId = query.playerId;
  if (query.playerName) request.playerName = query.playerName;
  if (query.orderNo) request.orderNo = query.orderNo;
  if (query.laserNo) request.laserNo = query.laserNo;
  if (query.orderStatus.length > 0) request.orderStatusIds = toIds(query.orderStatus);
  if (query.account.length > 0) request.orderAccountIds = toIds(query.account);
  if (query.buildLocation.length > 0) request.buildLocationIds = toIds(query.buildLocation);
  if (query.clubSupply.length > 0) request.headTypeIds = toIds(query.clubSupply);
  if (query.tourRep.length > 0) request.appUserIds = toIds(query.tourRep);
  if (currentPage === OrdersPageType.Components) {
    if (query.shipFrom?.length) request.inventoryLocationIds = toIds(query.shipFrom);
    if (query.shipTo?.length) request.buildLocationIds = toIds(query.shipTo);
  }
  if (query.requestedShipDate) {
    request.inHandDateFrom = query.requestedShipDate;
    request.inHandDateTo = query.requestedShipDate;
  }
  if (query.orderDateFrom) {
    request.orderDateFrom = query.orderDateFrom;
    request.orderDateTo = query.orderDateTo;
  }
  if (query.filters.searchUserDataOnly) request.searchUserDataOnly = true;

  return request;
};
